import ListItem from "../../../../components/ListItem";


const ProjectsList = () => {
    return (
        <div className="ProjectsList">
            <h2>Project List</h2>
            <ListItem endpoint="projects"/>
        </div>
    );
};
export default ProjectsList;
